import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, ReplaySubject, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

const COMMERCE_BACKEND_URL = environment.commerceUrl + '/ecommerce/';
const ITEMS_BACKEND_URL = environment.apiUrl + '/items/';
const SECTEURS_BACKEND_URL = environment.apiUrl + '/secteurs/';
const SECTEURSV2_BACKEND_URL = environment.apiUrl + '/secteursV2/';
const TCP_BACKEND_URL = environment.apiUrl + '/queues/';
const SETTINGS_BACKEND_URL = environment.apiUrl + '/settings/';
const profiles_BACKEND_URL = environment.apiUrl + '/profiles/';
const COMMANDS_BACKEND_URL = environment.apiUrl + '/commands/';
const TRIPS_BACKEND_URL = environment.apiUrl + '/trips/';

@Injectable({
  providedIn: 'root',
})
export class TaxisService {
  // Private

  private _loungesData: BehaviorSubject<any | null> = new BehaviorSubject(null);
  private _secteurs: ReplaySubject<any> = new ReplaySubject();
  private _countries: BehaviorSubject<any | null> = new BehaviorSubject(null);
  _settings: BehaviorSubject<any | null> = new BehaviorSubject(null);
  private _retailers: BehaviorSubject<any | null> = new BehaviorSubject([]);
  private _popularSecteurs: BehaviorSubject<any | null> = new BehaviorSubject(
    []
  );
  private _returnToStep1: BehaviorSubject<any | null> = new BehaviorSubject(
    false
  );
  /**
   * Constructor
   */
  constructor(private _httpClient: HttpClient) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for avg time
   */
  get loungesData$(): Observable<any> {
    return this._loungesData.asObservable();
  }

  /**
   * Getter for avg time
   */
  get popularSecteurs$(): Observable<any> {
    return this._popularSecteurs.asObservable();
  }

  /**
   * Getter for avg time
   */
  get settings$(): Observable<any> {
    return this._settings.asObservable();
  }
  /**
   * Getter for avg time
   */
  get destinationData$(): Observable<any> {
    return this._destinationData.asObservable();
  }
  /**
   * Getter for countries
   */
  get countries$(): Observable<any> {
    return this._countries.asObservable();
  }

  /**
   * Getter for avg time
   */
  get secteurs$(): Observable<any> {
    return this._secteurs.asObservable();
  }

  /**
   * Getter for avg time
   */
  get retailers$(): Observable<any> {
    return this._retailers.asObservable();
  }
    private _departureData: BehaviorSubject<any | null> = new BehaviorSubject(
    null
  );
  private _destinationData: BehaviorSubject<any | null> = new BehaviorSubject(
    null
  );
    /**
   * Getter for avg time
   */
  get departureData$(): Observable<any> {
    return this._departureData.asObservable();
  }

  /**
   * Getter for returnToStep1
   */
  get returnToStep1$(): Observable<any> {
    return this._returnToStep1.asObservable();
  }

  updateDepartureData(data: any): void {
    console.log('UPDATE DEPARTURE DATA ==> ', data);
    this._departureData.next(data);
  }

  updateDestinationData(data: any): void {
    console.log('UPDATE DESTINATION DATA ==> ', data);
    this._destinationData.next(data);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Place order
   */
  pay(data: any): Observable<any> {
    console.log(data)
    const { hostname } = new URL(window.location.href);
    let [subdomain] = hostname.split('.');
    if (!subdomain || subdomain === 'localhost') {
      subdomain = 'bouhou';
    }

    return this._httpClient
      .post(COMMERCE_BACKEND_URL + 'serve', data, {
        headers: new HttpHeaders({
          path: 'kechcab',
          // Accept: 'text/html, application/xhtml+xml, */*',
        }),
        //responseType: 'text' as 'text',
      })
      .pipe(
        tap((response: any) => {
          console.log('Payment Intent RESPONSE ==> ', response);
          return response;
        })
        // catchError((err) => {
        //   console.log('error while paying ==> ', err);
        //   return of(false);
        // })
      );
  }

  getDepart(search: string = ''): Observable<any> {
    return this._httpClient
      .get<any>(TCP_BACKEND_URL + 'depart/secteurs', {
        params: {
          secteur: '' + search,
        },
      })
      .pipe(
        tap((response) => {
          console.log('GET DEPART RESPONSE ===> ', response);
          return response;
        })
      );
  }

  getDomainDepart(search: string = ''): Observable<any> {
    return this._httpClient
      .get<any>(TCP_BACKEND_URL + 'depart/domain', {
        params: {
          secteur: '' + search,
        },
      })
      .pipe(
        tap((response) => {
          console.log('GET DOMAIN DEPART RESPONSE ===> ', response);
          return response;
        })
      );
  }

  checkClientToken(): Observable<any> {
    return this._httpClient.get<any>(profiles_BACKEND_URL + 'client/user').pipe(
      catchError(() => {

        this.logout();
        return of({ success: false });
      }),
      tap((response) => {
        console.log('CHECK CLIENT VALID RESPONSE ===> ', response);
        if(!response.success) this.logout();
        return response;
      })
    );
  }

  logout(){
    // localStorage.removeItem('clientToken');
  }

  /**
   * Place order
   */
  fetchCmiData(data: {
    secteurValue: {
      ref: string;
      amount: number;
    };
    ref: string;
    amount: number;
    cstmPass: string;
  }): Observable<any> {
    console.log('PAY SPECIAL DATA ==> ', data);
    return this._httpClient
      .post(COMMERCE_BACKEND_URL + 'serve', data, {
        headers: new HttpHeaders({
          path: 'wetaxi_wci',
        }),
      })
      .pipe(
        catchError((err) => {
          console.log('error while paying ==> ', err);
          return of(null);
        }),
        tap((response: any) => {
          console.log('Payment Intent RESPONSE ==> ', response);
          return response;
        })
      );
  }

  fetchTrip(id:any): Observable<any> {
    return this._httpClient.get<any>(TRIPS_BACKEND_URL + 'fetch/' + id).pipe(
      catchError(() => {
        return of({ success: false });
      }),
      tap((response) => {
        console.log('FETCH TRIP RESPONSE ===> ', response);
        return response;
      })
    );
  }

  fetchPopularTrip(id:any): Observable<any> {
    return this._httpClient.get<any>(TRIPS_BACKEND_URL + 'public/fetch/' + id).pipe(
      catchError(() => {
        return of({ success: false });
      }),
      tap((response) => {
        console.log('FETCH POPULAR TRIP RESPONSE ===> ', response);
        return response;
      })
    );
  }

  /**
   * Place order cash gitex only non-clients
   */
  paySpecial(data: any): Observable<any> {
    console.log('CREATE GITEX CASH TICKET ==> ', data);
    return this._httpClient
      .post(COMMANDS_BACKEND_URL + 'gitex/ticket', data)
      .pipe(
        catchError((err) => {
          return of({ success: false, message: 'Something went wrong!' });
        }),
        tap((response: any) => {
          console.log('CREATE TICKET CASH GITEX RESPONSE ==> ', response);
          return response;
        })
        // catchError((err) => {
        //   console.log('error while paying ==> ', err);
        //   return of(false);
        // })
      );
  }

  /**
   * Place order gitex and can also be custom trip
   */
  paySpecialV2(data: any): Observable<any> {
    console.log('CREATE GITEX CASH TICKET ==> ', data);
    return this._httpClient
      .post(COMMANDS_BACKEND_URL + 'gitex-custom/ticket', data)
      .pipe(
        catchError((err) => {
          console.log(err);
          return of({ success: false, message: 'Something went wrong!' });
        }),
        tap((response: any) => {
          console.log('CREATE TICKET CASH CUSTOM RESPONSE ==> ', response);
          return response;
        })
        // catchError((err) => {
        //   console.log('error while paying ==> ', err);
        //   return of(false);
        // })
      );
  }

    paySpecialV3(data: any): Observable<any> {
      const { hostname } = new URL(window.location.href);
      let [subdomain] = hostname.split('.');
      if (!subdomain || subdomain === 'localhost') {
        subdomain = 'bouhou';
      }
      console.log('PAY SPECIAL DATA ==> ', data);
      return this._httpClient
        .post(COMMERCE_BACKEND_URL + 'serve', data, {
          headers: new HttpHeaders({
            path: 'kechcab_special',
            // Accept: 'text/html, application/xhtml+xml, */*',
          }),
          //responseType: 'text' as 'text',
        })
        .pipe(
          tap((response: any) => {
            console.log('Payment Intent RESPONSE ==> ', response);
            return response;
          })
          // catchError((err) => {
          //   console.log('error while paying ==> ', err);
          //   return of(false);
          // })
        );
    }
  printImage(data: any): Observable<boolean> {
    //let formData = new FormData();

    //formData.append("image", image);

    return this._httpClient
      .post<boolean>('http://localhost:5001/amount/', data)
      .pipe(
        catchError((error) => {
          // Log the error
          console.error('Error ==> ', error);
          //throwError(error);
          // Navigate to there
          // Throw an error
          return of(false);
        }),
        tap((resp) => {
          console.log('Print response ==> ', resp);
          return resp;
        })
      );
  }

  getSearchSecteurs(
    search: string = '',
    retailerId: string = ''
  ): Observable<any> {
    return this._httpClient
      .get<any>(
        SECTEURS_BACKEND_URL + 'search-client-retailer/special-secteurs',
        {
          params: {
            search: '' + search,
            retailerId: '' + retailerId,
          },
        }
      )
      .pipe(
        tap((response) => {
          console.log('SEARCH SECTEUR RESPONSE ===> ', response);
          this._secteurs.next(response);

          return response;
        })
      );
  }

  clearSecteurs() {
    this._secteurs.next([]);
  }

  returnGoogleSecteur(data:any): Observable<any> {
    console.log('RETURN GOOGLE SECTEUR DATA ==> ', data);
    return this._httpClient
      .post<any>(SECTEURSV2_BACKEND_URL + 'google/gitex-secteur', data)
      .pipe(
        tap((response) => {
          console.log('RETURN GOOGLE SECTEUR RESPONSE ===> ', response);
          return response;
        })
      );
  }

  calculePriceTrips(data:any){
      console.log('CALCULATE PRICE TRIPS DATA ==> ', data);
      return this._httpClient
        .post<any>(TRIPS_BACKEND_URL + 'calculate-price/public', data)
        .pipe(
          tap((response) => {
            console.log('CALCULATE PRICE TRIPS RESPONSE ===> ', response);
            return response;
          })
        );
  }

  getClosestSecteur(
    lat: number = 0,
    lng: number = 10,
    locality: string = ''
  ): Observable<any> {
    return this._httpClient
      .get<any>(SECTEURSV2_BACKEND_URL + 'kechcab/secteur', {
        params: {
          lat: lat,
          lng: lng,
          locality: '' + locality,
        },
      })
      .pipe(
        tap((response) => {
          console.log('CLOSEST SECTEUR RESPONSE ===> ', response);
          return response;
        })
      );
  }

  getLoungeData(): Observable<any> {
    return this._httpClient.get<any>(ITEMS_BACKEND_URL + 'lounge/all').pipe(
      tap((response) => {
        this._loungesData.next(response);
        return response;
      })
    );
  }

  /**
   * Get countries
   */
  getCountries(): Observable<any> {
    return this._httpClient.get<any>('api/apps/contacts/countries').pipe(
      tap((countries) => {
        this._countries.next(countries);
      })
    );
  }

  /**
   * Update map stat
   *
   * @param data
   */
  updateMapStat(data: any): Observable<any> {
    return this._httpClient
      .post<any>(TCP_BACKEND_URL + 'map-stat/save', data)
      .pipe(
        map((result) => {
          console.log('UPDATE MAPSTAT RESULT ====> ', result);
          // Return the added event
          return result;
        })
      );
  }

  /**
   * Fetch airports
   * @param search
   * @param retailerId
   * @returns
   */
  getRetailers(): Observable<any> {
    return this._httpClient.get<any>(SETTINGS_BACKEND_URL + 'retailers').pipe(
      tap((response) => {
        console.log('FETCH RETAILERS RESPONSE ==> ', response);
        this._retailers.next(response);
        return response;
      })
    );
  }

  /**
   * Fetch popular addresses
   * @param search
   * @param retailerId
   * @returns
   */
  getPopularAddresses(id:any): Observable<{ documents: any[] }> {
    return this._httpClient
      .get<{ documents: any[] }>(
        SECTEURSV2_BACKEND_URL + 'popular/addresses/' + id
      )
      .pipe(
        catchError((err) => {
          console.log('ERROR FETCHING POPULAR ADDRESSES');
          return [];
        }),
        tap((response) => {
          console.log('FETCH POPULAR ADDRESSES RESPONSE ==> ', response);
          this._popularSecteurs.next(response?.documents ?? []);
          return response?.documents ?? [];
        })
      );
  }

  goBackToStep1() {
    this._returnToStep1.next(true);
  }


  submitTrip(data:any): Observable<any> {
    console.log('SUBMIT TRIP DATA ==> ', data);
    return this._httpClient
      .post<any>(TRIPS_BACKEND_URL + 'order', data)
      .pipe(
        tap((response) => {
          console.log('SUBMIT TRIP RESPONSE ===> ', response);
          return response;
        })
      );
  }

    cancelTrip(tripId: string, reason?: string): Observable<any> {
    const url = `${TRIPS_BACKEND_URL}cancel/${tripId}`;
    return this._httpClient
      .put<any>(url, {
        orderId: tripId,
        cancelReason: reason || 'Client cancelled from panel trips',
      })
      .pipe(
        tap((response) => {
          if (response.success) {
            // this.toastService.success('Trip cancelled successfully');
          }
        }),
        catchError((error) => {
          // this.toastService.error('Error cancelling trip');
          return of(null);
        })
      );
  }

  getTicketById(ticketId: string): Observable<any> {
    return this._httpClient.get<any>(TRIPS_BACKEND_URL + '/' + ticketId).pipe(
      tap((response) => {
        console.log('TICKET INFO RESPONSE ===> ', response);
        return response;
      })
    );
  }
}
